"use strict";

{
  const dialogs = document.querySelectorAll("dialog");
  const modal1 = document.getElementById("modal1");
  const panelMenu = modal1?.querySelector('[data-modal-panel="menu"]');
  const panelMansion = modal1?.querySelector('[data-modal-panel="mansion"]');
  const panelRedirect = modal1?.querySelector('[data-modal-panel="redirect"]');
  const panelTelPc = modal1?.querySelector('[data-modal-panel="tel-pc"]');

  const mqPcMin768 = window.matchMedia("(min-width: 768px)");

  const resetModalPanels = () => {
    if (!modal1 || !panelMenu || !panelRedirect || !panelTelPc) return;
    panelMenu.hidden = false;
    if (panelMansion) panelMansion.hidden = true;
    panelRedirect.hidden = true;
    panelTelPc.hidden = true;
    modal1.classList.remove("-step-redirect", "-step-tel-pc");
    modal1.setAttribute("aria-labelledby", "modal-head1");
    modal1.setAttribute("aria-describedby", "modal-text1");
  };

  if (modal1) {
    modal1.addEventListener("close", resetModalPanels);
  }

  const open = document.querySelectorAll(".p-modal__open-btn");
  open.forEach((button) => {
    button.addEventListener("click", () => {
      const dialogId = button.getAttribute("data-dialog");
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      if (dialog === modal1) {
        resetModalPanels();
      }
      globalThis.showModalKeepScroll(dialog);
    });
  });

  const close = document.querySelectorAll(".p-modal__close-btn");
  close.forEach((button) => {
    button.addEventListener("click", () => {
      const dialog = button.closest("dialog");
      if (!dialog) return;
      dialog.classList.remove("js-show");
      dialog.close();
    });
  });

  dialogs.forEach((dialogEl) => {
    dialogEl.addEventListener("click", (event) => {
      if (event.target.closest(".p-modal__inner, .p-contactMailConfirm__inner") === null) {
        dialogEl.classList.remove("js-show");
        dialogEl.close();
      }
    });
  });

  if (modal1 && panelMenu && panelRedirect && panelTelPc) {
    const COOKIE_CONTACT_BLOCK = "propane_contact_block_reason";
    const COOKIE_EXPIRE_DAYS_24H = 1;
    const VALID_CONTACT_REASONS = new Set([
      "cancel_only",
      "opening_attendance",
      "other_inquiry",
    ]);

    function setContactBlockCookie(name, value, days) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(
        value
      )}; expires=${expires}; path=/; SameSite=Lax`;
    }

    function getContactBlockCookie(name) {
      const row = document.cookie.split("; ").find((r) => r.startsWith(`${name}=`));
      if (!row) {
        return null;
      }
      return decodeURIComponent(row.slice(name.length + 1));
    }

    function isContactApplyBlocked() {
      const v = getContactBlockCookie(COOKIE_CONTACT_BLOCK);
      return v !== null && v.trim() !== "";
    }

    function showRedirectStep() {
      panelMenu.hidden = true;
      if (panelMansion) panelMansion.hidden = true;
      panelRedirect.hidden = false;
      panelTelPc.hidden = true;
      modal1.classList.add("-step-redirect");
      modal1.classList.remove("-step-tel-pc");
      modal1.setAttribute("aria-labelledby", "modal-head2");
      modal1.removeAttribute("aria-describedby");
    }

    function showMansionStep() {
      panelMenu.hidden = true;
      if (panelMansion) panelMansion.hidden = false;
      panelRedirect.hidden = true;
      panelTelPc.hidden = true;
      modal1.classList.remove("-step-redirect", "-step-tel-pc");
      modal1.setAttribute("aria-labelledby", "modal-head-mansion");
      modal1.setAttribute("aria-describedby", "modal-text-mansion");
    }

    modal1.querySelectorAll(".p-modal__link.-link--mansion").forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        showMansionStep();
      });
    });

    modal1.querySelectorAll(".p-modal__link.-link--apply").forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        if (isContactApplyBlocked()) {
          e.preventDefault();
          showRedirectStep();
          return;
        }
        if (mqPcMin768.matches) {
          e.preventDefault();
          panelMenu.hidden = true;
          if (panelMansion) panelMansion.hidden = true;
          panelRedirect.hidden = true;
          panelTelPc.hidden = false;
          modal1.classList.add("-step-tel-pc");
          modal1.classList.remove("-step-redirect");
          modal1.setAttribute("aria-labelledby", "modal-head-tel-pc");
          modal1.setAttribute("aria-describedby", "modal-text-tel-pc");
        } else {
          modal1.classList.remove("js-show");
          modal1.close();
        }
      });
    });

    modal1.querySelectorAll(".p-modal__link.-link--redirect").forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const raw = anchor.getAttribute("data-propane-contact-reason");
        const reason = raw ? raw.trim() : "";
        if (reason && VALID_CONTACT_REASONS.has(reason)) {
          setContactBlockCookie(COOKIE_CONTACT_BLOCK, reason, COOKIE_EXPIRE_DAYS_24H);
        }
        showRedirectStep();
      });
    });

    const telCopyBtn = modal1.querySelector("[data-tel-pc-copy]");
    const telNumEl = modal1.querySelector("[data-tel-pc-num]");
    if (telCopyBtn && telNumEl) {
      telCopyBtn.addEventListener("click", () => {
        const fromAttr = telCopyBtn.getAttribute("data-tel-pc-copy");
        const text = (fromAttr && fromAttr.trim()) || telNumEl.textContent.trim();
        if (!text) {
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).catch(() => {});
          return;
        }
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      });
    }

    // PC 電話案内（-step-tel-pc）表示中にブレークポイントが SP になったら閉じる
    // （CSS の display:none だけでは dialog[open]＋backdrop が残り背面が操作できない）
    function closeTelPcStepIfSpViewport() {
      if (!modal1.open) return;
      if (!modal1.classList.contains("-step-tel-pc")) return;
      if (mqPcMin768.matches) return;
      modal1.classList.remove("js-show");
      modal1.close();
    }

    window.addEventListener("resize", closeTelPcStepIfSpViewport);
    if (typeof mqPcMin768.addEventListener === "function") {
      mqPcMin768.addEventListener("change", closeTelPcStepIfSpViewport);
    } else if (typeof mqPcMin768.addListener === "function") {
      mqPcMin768.addListener(closeTelPcStepIfSpViewport);
    }
  }
}
